import { OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { BehaviorSubject, combineLatest } from "rxjs";
import { Organisations } from "../../store/actions/index";
import * as selectors from "../../store/reducers/index";
import { FormControl } from "@angular/forms";
import { map } from "rxjs/operators";
var OrganisationsComponent = /** @class */ (function () {
    function OrganisationsComponent(store) {
        this.store = store;
        this.currentFilter = new BehaviorSubject("enabled");
        this.filterControl = new FormControl("enabled");
        this.organisations = combineLatest(this.store.select(selectors.getAll(selectors.ORGANISATIONS)), this.currentFilter).pipe(map(function (_a) {
            var orgs = _a[0], filter = _a[1];
            if (filter == "enabled") {
                return orgs.filter(function (org) { return org.enabled; });
            }
            return orgs;
        }));
        this.loading$ = this.store.select(selectors.getLoadingAll(selectors.ORGANISATIONS));
    }
    OrganisationsComponent.prototype.ngOnInit = function () {
        this.store.dispatch(Organisations.RequestAllAction);
    };
    OrganisationsComponent.prototype.updateFilter = function () {
        this.currentFilter.next(this.filterControl.value);
    };
    return OrganisationsComponent;
}());
export { OrganisationsComponent };
